module.exports = __webpack_public_path__ + "media/images/comment-manager1-f0b2c1a0.png";